
webpack.register(
    'modules/history/history',
    function() {
        return import('modules/history/history');
    },
    true
);